
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitolonavalacab() {



    const cardData =
    {
        keyword: ' Mumbai to Lonavala Cab   ',
        heading: 'Deva Cabs: Mumbai to Lonavala Cab  ',
        headingDescription: 'Deva Cabs offers smooth and scenic cab services from Mumbai to Lonavala, ideal for weekend getaways, romantic trips, and family vacations. Just 85 km from Mumbai, Lonavala is a popular hill station, and our well-maintained cabs ensure a comfortable ride through the beautiful Western Ghats. Choose from Sedans, SUVs, or Innova Crysta with experienced drivers for a safe and relaxing journey. With flexible pickup options, fixed fares, and 24/7 availability, Deva Cabs makes your Mumbai to Lonavala trip easy and enjoyable.',

        top: 'Top Places to Visit in Lonavala with Deva Cabs',

"topPlaces": [
  {
    "title": "Bhushi Dam",
    "location": "Lonavala, Maharashtra",
    "description": "Bhushi Dam is one of the most popular tourist attractions in Lonavala, especially during the monsoon season. Built on the Indrayani River, the dam creates natural steps with gushing water, offering a fun and refreshing experience. It’s a perfect spot for families and friends to enjoy a scenic picnic in the lap of nature."
  },
  {
    "title": "Tiger’s Leap",
    "location": "Lonavala, Maharashtra",
    "description": "Tiger’s Leap is a cliff-top viewpoint that offers panoramic views of the lush valley below. Named for its resemblance to a leaping tiger, the site is known for its echo point and misty landscapes, especially during monsoons. It’s a great spot for photography and nature lovers seeking a quiet escape."
  },
  {
    "title": "Karla Caves",
    "location": "Lonavala, Maharashtra",
    "description": "The Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BCE. Known for their large prayer hall (Chaitya) and intricately carved sculptures, the caves reflect fine ancient Indian craftsmanship. A short uphill trek leads visitors to this heritage site surrounded by scenic views."
  },
  {
    "title": "Rajmachi Fort",
    "location": "Near Lonavala, Maharashtra",
    "description": "Rajmachi Fort is a historic hill fort that offers breathtaking views of the Sahyadri ranges. The trek to Rajmachi is a favorite among adventure seekers and history enthusiasts. The twin forts of Shrivardhan and Manaranjan within the complex add to its charm and cultural value."
  },
  {
    "title": "Lonavala Lake",
    "location": "Lonavala, Maharashtra",
    "description": "Lonavala Lake is a serene and scenic spot, especially during the monsoon when it fills with rainwater. Surrounded by green hills, it is ideal for a quiet evening walk, birdwatching, or simply relaxing by the water. The peaceful ambiance makes it a hidden gem away from the tourist rush."
  },
  {
    "title": "Lion’s Point",
    "location": "Lonavala, Maharashtra",
    "description": "Lion’s Point is a scenic viewpoint located midway between Bhushi Dam and Aamby Valley. Known for its sweeping views of valleys, waterfalls, and sunsets, it becomes a misty paradise during monsoons. Local food stalls and wind-swept cliffs make it a perfect stop for nature lovers."
  },
  {
    "title": "Pawna Lake",
    "location": "Near Lonavala, Maharashtra",
    "description": "Pawna Lake is an artificial reservoir surrounded by hills, making it a popular camping and weekend getaway destination. Visitors can enjoy stargazing, bonfires, kayaking, and a peaceful overnight stay by the lake. The setting offers a unique blend of adventure and tranquility."
  },
  {
    "title": "Lohagad Fort",
    "location": "Near Lonavala, Maharashtra",
    "description": "Lohagad Fort is one of the most visited trekking spots near Lonavala. With an easy trail and historic ruins at the top, it’s perfect for beginners and families. The famous ‘Vinchu Kata’ (scorpion tail-shaped rampart) offers stunning views, especially in monsoon when the path is covered in greenery and mist."
  },
  {
    "title": "Ryewood Park",
    "location": "Lonavala, Maharashtra",
    "description": "Ryewood Park is a well-maintained botanical garden spread across vast green lawns and shaded paths. It features tall trees, colorful flowerbeds, and a playground for kids. Ideal for families and couples looking for a peaceful and scenic place within the town."
  },
  {
    "title": "Wax Museum",
    "location": "Lonavala, Maharashtra",
    "description": "The Lonavala Wax Museum houses life-size wax statues of celebrities, historical figures, and famous personalities. It’s a fun indoor attraction that appeals to all age groups and makes for a great photo opportunity. The museum adds a touch of novelty and entertainment to your Lonavala trip."
  }
],



"services": [
  {
    "name": "Mumbai to Lonavala Cab",
    "description": "Deva Cabs offers reliable and comfortable cab services from Mumbai to Lonavala, perfect for weekend getaways, family outings, or corporate trips. Our fleet includes a variety of vehicles suited to your group size and preferences, with professional drivers ensuring a smooth and safe journey to this popular hill station known for its scenic beauty and pleasant climate."
  },
  {
    "name": "Book cab Mumbai to Lonavala",
    "description": "Booking your Mumbai to Lonavala cab with Deva Cabs is simple and hassle-free. Use our online platform or call to reserve your preferred vehicle, from economical sedans to luxury SUVs. Get instant booking confirmation, flexible payment options, and transparent pricing to enjoy a seamless travel experience every time."
  },
  {
    "name": "One-way cab Mumbai to Lonavala",
    "description": "For travelers looking for a straightforward one-way trip from Mumbai to Lonavala, Deva Cabs provides punctual and affordable options. Whether it’s a business visit, a day trip, or a quick weekend escape, our well-maintained vehicles and courteous drivers ensure you arrive comfortably and on time."
  },
  {
    "name": "Round trip taxi Mumbai to Lonavala",
    "description": "Planning a round trip from Mumbai to Lonavala? Choose Deva Cabs for flexible and reliable round trip taxi services that let you explore the hill station at your own pace. Enjoy the convenience of door-to-door service, with your driver ready to pick you up when your trip concludes."
  },
  {
    "name": "SUV cab Mumbai to Lonavala",
    "description": "Travel in spacious comfort with our SUV cab services from Mumbai to Lonavala. Ideal for families or groups with extra luggage, our SUVs come with air conditioning, ample legroom, and smooth ride quality, ensuring a relaxing trip through the winding routes of the Western Ghats."
  },
  {
    "name": "AC cab Mumbai to Lonavala",
    "description": "Beat the heat and enjoy a refreshing ride with Deva Cabs’ fully air-conditioned Mumbai to Lonavala cabs. Our AC vehicles guarantee a pleasant climate-controlled environment, so you can relax and enjoy the scenic drive in total comfort."
  },
  {
    "name": "Mumbai to Lonavala sightseeing cab",
    "description": "Explore the picturesque spots of Lonavala with Deva Cabs’ sightseeing cab services. Our knowledgeable drivers can guide you to the best attractions, including waterfalls, forts, and viewpoints, while providing comfortable and safe transport throughout your sightseeing adventure."
  },
  {
    "name": "Chauffeur cab Mumbai to Lonavala",
    "description": "Experience professional chauffeur-driven cab services from Mumbai to Lonavala. Our experienced drivers prioritize your safety and comfort, offering courteous service, local route expertise, and timely arrivals to make your journey as smooth and enjoyable as possible."
  },
  {
    "name": "Affordable Mumbai to Lonavala cab",
    "description": "Deva Cabs provides budget-friendly Mumbai to Lonavala cab options without compromising on quality or comfort. Enjoy transparent pricing, no hidden charges, and reliable service, making your trip economical yet hassle-free for both solo travelers and groups."
  },
  {
    "name": "Luxury car Mumbai to Lonavala",
    "description": "For travelers who want to indulge in style, our luxury car rentals from Mumbai to Lonavala feature premium vehicles with plush interiors, advanced amenities, and a smooth ride. Perfect for special occasions, corporate travelers, or anyone who values first-class comfort."
  },
  {
    "name": "Sedan cab hire Mumbai to Lonavala",
    "description": "Opt for our sedan cab hire services from Mumbai to Lonavala for an efficient and comfortable travel experience. Our sedans are ideal for small families or business travelers looking for a neat, well-maintained vehicle with attentive service."
  },
  {
    "name": "Online cab booking Lonavala from Mumbai",
    "description": "Deva Cabs offers convenient online cab booking for trips from Mumbai to Lonavala. Easily select your vehicle, choose your travel dates, and receive instant confirmation through our website or app. Our user-friendly platform streamlines your travel planning."
  },
  {
    "name": "Family cab Mumbai to Lonavala",
    "description": "Travel comfortably with your family from Mumbai to Lonavala using Deva Cabs’ family-friendly cab services. Our spacious vehicles, child safety features, and courteous drivers ensure a safe and enjoyable journey for travelers of all ages."
  },
  {
    "name": "Mumbai to Lonavala weekend trip cab",
    "description": "Plan your perfect weekend getaway with Deva Cabs’ Mumbai to Lonavala weekend trip cab services. Our flexible packages and comfortable vehicles let you relax and enjoy the natural beauty, hill station climate, and local attractions without any travel worries."
  },
  {
    "name": "Fast cab to Lonavala from Mumbai",
    "description": "In a hurry to reach Lonavala from Mumbai? Deva Cabs provides fast and reliable cab services, with expert drivers familiar with the quickest routes and traffic conditions. Enjoy a timely and safe journey without compromising comfort or convenience."
  }
],
"tableData": [
  ["Mumbai to Lonavala Cab", "-Book cab Mumbai to Lonavala"],
  ["One-way cab Mumbai to Lonavala", "-Round trip taxi Mumbai to Lonavala"],
  ["SUV cab Mumbai to Lonavala", "-AC cab Mumbai to Lonavala"],
  ["Mumbai to Lonavala sightseeing cab", "-Chauffeur cab Mumbai to Lonavala"],
  ["Affordable Mumbai to Lonavala cab", "-Luxury car Mumbai to Lonavala"],
  ["Sedan cab hire Mumbai to Lonavala", "-Online cab booking Lonavala from Mumbai"],
  ["Family cab Mumbai to Lonavala", "-Mumbai to Lonavala weekend trip cab"],
  ["Fast cab to Lonavala from Mumbai", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and Hassle-Free Mumbai to Lonavala Cab Service",
    "WhyChoosedescription": "Our Mumbai to Lonavala cab service ensures a smooth and dependable travel experience for your weekend getaway, family outing, or corporate retreat. We focus on punctual pickups, efficient route planning, and seamless coordination so that you can sit back and enjoy the scenic drive to Lonavala without stress or delays. Whether you’re booking last-minute or in advance, we’ve got you covered."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles for a Relaxing Trip",
    "WhyChoosedescription": "The 2.5 to 3-hour journey from Mumbai to Lonavala can be tiring without the right vehicle. That’s why our fleet includes air-conditioned, clean, and spacious cars with comfortable seats and ample luggage space. Whether you’re traveling solo, as a couple, or with a group, you’ll enjoy a peaceful ride with soothing interiors, smooth suspension, and attentive driver service throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Scenic Route Knowledge",
    "WhyChoosedescription": "Our professional drivers are experts on the Mumbai–Pune Expressway and know the best routes, viewpoints, and food stops en route to Lonavala. They're trained in safety and customer service, offering a courteous and smooth driving experience. Whether you prefer a fast route or a scenic drive through the Ghats, our drivers will tailor the trip to suit your preferences."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "We believe in honest pricing. When you book a Mumbai to Lonavala cab with us, the fare includes fuel, tolls, and driver allowances. There are no surprise charges—just clear and competitive rates that give you great value for money. You’ll receive a full price breakdown at the time of booking, allowing you to plan your trip budget with confidence."
  },
  {
    "WhyChooseheading": "Available 24/7 for Weekend Plans and Last-Minute Getaways",
    "WhyChoosedescription": "Planning a spontaneous trip to Lonavala? No problem. Our cab service runs 24/7 to suit your travel plans, whether you’re heading out on a weekday afternoon or early morning over the weekend. Even during peak seasons or holidays, we ensure availability so your escape to the hills is never delayed."
  },
  {
    "WhyChooseheading": "Easy Booking Process with Instant Confirmation",
    "WhyChoosedescription": "Booking your ride from Mumbai to Lonavala is fast, secure, and user-friendly. Use our website or call our customer support to reserve your cab in just a few steps. Receive instant confirmation, detailed trip information, and real-time driver updates to keep your travel experience organized and stress-free."
  },
  {
    "WhyChooseheading": "Safety-Focused Travel Experience",
    "WhyChoosedescription": "We prioritize your safety on every trip. Our cabs are regularly inspected, cleaned, and equipped with GPS tracking, seat belts, and first-aid kits. Our drivers adhere to all traffic regulations and are trained in defensive driving to ensure your ride to Lonavala is not just enjoyable, but also completely safe."
  },
  {
    "WhyChooseheading": "Personalized Services for Every Traveler",
    "WhyChoosedescription": "Whether you're planning a romantic trip, a family picnic, or a group tour, we offer personalized travel options to meet your needs. From vehicle upgrades to flexible pickup points and customized itineraries, we go the extra mile to make your Mumbai to Lonavala journey truly memorable."
  }
]




















    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Lonavala with Deva Cabs?",
    answer: "Yes, Deva Cabs provides comfortable and reliable cab services from Mumbai to Lonavala for day trips, weekend getaways, and more."
  },
  {
    question: "How long does it take to travel from Mumbai to Lonavala by cab?",
    answer: "The journey typically takes around 2 to 3 hours depending on traffic."
  },
  {
    question: "What types of vehicles are available for Mumbai to Lonavala transfers?",
    answer: "We offer sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers suitable for solo travelers and groups."
  },
  {
    question: "Can I pre-book a cab for Mumbai to Lonavala?",
    answer: "Yes, you can pre-book your cab through our website, mobile app, or customer support for hassle-free service."
  },
  {
    question: "Are one-way cab services available from Mumbai to Lonavala?",
    answer: "Yes, we offer one-way cab services without return fare requirements."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll and parking fees are usually extra and will be clearly communicated during booking."
  },
  {
    question: "Is your cab service available late at night or early morning?",
    answer: "Yes, Deva Cabs operates 24/7 to accommodate your travel schedule."
  },
  {
    question: "Is it safe to travel alone from Mumbai to Lonavala by cab?",
    answer: "Absolutely. Our drivers are verified and trained to provide a safe and comfortable journey."
  },
  {
    question: "Will the driver wait if I am delayed?",
    answer: "Yes, our drivers are flexible and will wait if informed about any delays."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Lonavala cab services?",
    answer: "We offer punctual service, well-maintained vehicles, professional drivers, and transparent pricing for your convenience."
  }
];

const testimonialData = [
  {
    id: 29,
    name: 'Mr. Rahul Shah',
    role: 'Weekend Traveler',
    review: 'Booked a cab from Mumbai to Lonavala with Deva Cabs. The trip was smooth, and the driver was very professional. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 30,
    name: 'Ms. Neeta Joshi',
    role: 'Tourist',
    review: 'Deva Cabs made our Lonavala trip from Mumbai easy and comfortable. The vehicle was clean and the driver courteous.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lonavala Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-lonavala-cab.jpg", // Replace with actual image URL if different
  "description": "Book Mumbai to Lonavala cab with Deva Cabs for a relaxing getaway. Choose from hatchback, sedan, SUV, or tempo traveller for your one-way or round trip journey. Affordable fares, on-time pickup, and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-lonavala-cab"
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Lonavala Cab | One Way & Round Trip Taxi - Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Lonavala cab with Deva Cabs at affordable prices. Perfect for weekend getaways or day trips. Choose from sedan, SUV, or tempo traveller. On-time service and professional drivers guaranteed." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Lonavala Cab, Cab from Mumbai to Lonavala, Mumbai to Lonavala Taxi, One Way Cab Mumbai to Lonavala, Mumbai to Lonavala Car Rental, Mumbai to Lonavala Outstation Cab, Deva Cabs Mumbai to Lonavala, Lonavala Trip Taxi from Mumbai, Mumbai to Lonavala SUV, Sedan Cab Mumbai to Lonavala, Online Cab Booking Lonavala, Weekend Trip Cab Mumbai to Lonavala, Tempo Traveller Mumbai to Lonavala" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitolonavalacab;